const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
};

/**
 * Minutes to ADD to UTC to reach the browser's local time.
 *
 * `getTimezoneOffset()` returns the opposite sign, which is a classic source of
 * off-by-one-day bugs — the negation happens here, once, so the study streak
 * rolls over at the user's midnight rather than UTC's.
 */
export function tzOffsetMinutes(): number {
  return -new Date().getTimezoneOffset();
}

export default config;
